import { TranslocoPipe } from '@jsverse/transloco';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent, IDGenerator } from 'vcp-common-ui-lib';
import { FormsModule } from '@angular/forms';

export declare type ThemeMode = 'dark' | 'light';

@Component({
    selector: 'vc-theme-toggle',
    templateUrl: './theme-toggle.component.html',
    styleUrls: ['./theme-toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoPipe, FormsModule, IconComponent],
})
export class ThemeToggleComponent {
    labelId: string = `toggle-label-${IDGenerator.generateID()}`;
    checked: boolean = false;

    @Input()
    set mode(value: ThemeMode) {
        if (value !== this._mode) {
            this._mode = value;
            this.checked = this._mode === 'dark';
        }
    }

    get mode(): ThemeMode {
        return this._mode;
    }

    private _mode: ThemeMode = 'light';

    @Output()
    modeChanged = new EventEmitter<ThemeMode>();
}
